import { Link } from 'react-router-dom';
import { Icon } from '../ui/Icon';
import { Media } from '../ui/Media';
import { clsBouton, Fil, Entete } from './partages';
import { HISTOIRE, PRODUITS, REGLAGES, VALEURS } from '../data/mock-data';

/** NOTRE MAISON — la page qui donne envie de payer un peu plus cher. */
export function Maison() {
  const photo = PRODUITS.find(p => p.id === 'p_cote_boeuf_28')?.photo;

  return (
    <main id="contenu">
      <div className="mx-auto max-w-[1180px] px-5 pt-6 sm:px-6">
        <Fil fils={[{ libelle: 'Notre maison' }]} />
      </div>

      {/* Ouverture éditoriale */}
      <section className="mx-auto grid max-w-[1180px] items-center gap-10 px-5 pb-14 pt-4 sm:px-6 lg:grid-cols-[1.1fr_1fr] lg:gap-16">
        <div>
          <p className="eyebrow">Depuis {REGLAGES.marque.depuis}</p>
          <h1 className="mt-3 text-balance text-[clamp(2.2rem,5.4vw,3.8rem)] leading-[1.02]">
            Quatre générations,<br /><span className="italic text-wine">un seul geste.</span>
          </h1>
          <p className="measure mt-5 text-[1.0625rem] leading-relaxed text-ink-soft">
            Marcel Duval a ouvert un comptoir à Sannois en 1922 avec une idée simple : on ne
            vend que ce qu’on a choisi. Cent ans plus tard, nous choisissons toujours nos animaux
            sur pied, nous les découpons nous-mêmes, et nous vous disons comment les cuire.
          </p>
          <p className="mt-4 max-w-xl text-[0.9375rem] leading-relaxed text-muted">
            Ce qui a changé, c’est la manière de commander. Ce qui n’a pas changé, c’est ce qui
            se passe derrière le comptoir.
          </p>
        </div>
        <div className="relative">
          <div className="overflow-hidden rounded-[26px] shadow-lift">
            <Media src={photo} alt="Le comptoir de la Maison Duval, à Sannois" teinte="wine" ratio="aspect-[4/5]" monogramme="1922" />
          </div>
          <div className="absolute -left-3 bottom-6 rounded-2xl bg-paper px-5 py-4 shadow-float">
            <p className="font-display text-2xl leading-none">1922</p>
            <p className="mt-1 text-[0.625rem] uppercase tracking-[0.16em] text-muted">Rue d’Argenteuil</p>
          </div>
        </div>
      </section>

      {/* Chronologie */}
      <section className="bg-linen/70 py-16 lg:py-24">
        <div className="mx-auto max-w-[900px] px-5 sm:px-6">
          <Entete surtitre="La chronologie" titre="Un siècle, cinq étapes" centre />
          <ol className="relative mt-10 space-y-8 border-l border-linen-deep pl-8 sm:pl-10">
            {HISTOIRE.map(h => (
              <li key={h.annee} className="relative">
                <span className="absolute -left-[41px] top-1 grid h-4 w-4 place-items-center rounded-full border-2 border-wine bg-paper sm:-left-[49px]" aria-hidden="true" />
                <p className="font-display text-2xl text-wine">{h.annee}</p>
                <h3 className="mt-1 text-xl">{h.titre}</h3>
                <p className="mt-1.5 max-w-xl text-[0.9375rem] leading-relaxed text-muted">{h.texte}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* Engagements */}
      <section id="engagements" className="mx-auto max-w-[1180px] scroll-mt-28 px-5 py-16 sm:px-6 lg:py-24">
        <Entete surtitre="Nos engagements" titre="Trois choses qu’on ne fera pas"
          texte="Un engagement se vérifie au comptoir, pas sur une page. Voici les nôtres." />
        <div className="mt-8 grid gap-5 sm:grid-cols-3">
          {VALEURS.map((v, i) => (
            <article key={v.titre} className="rounded-[22px] bg-surface p-6 shadow-soft">
              <span className="grid h-11 w-11 place-items-center rounded-full bg-brass-wash font-display text-lg text-brass-ink">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-4 text-xl">{v.titre}</h3>
              <p className="mt-2 text-[0.9375rem] leading-relaxed text-muted">{v.texte}</p>
            </article>
          ))}
        </div>
      </section>

      {/* Maturation */}
      <section className="bg-ink py-16 text-lin-50 lg:py-24">
        <div className="mx-auto grid max-w-[1180px] items-center gap-10 px-5 sm:px-6 lg:grid-cols-2">
          <div>
            <p className="eyebrow text-brass-soft">Le cabinet</p>
            <h2 className="mt-3 font-display text-[clamp(1.9rem,3.4vw,2.8rem)] text-lin-50">Vingt-huit jours qui changent tout</h2>
            <p className="mt-4 max-w-lg text-[0.9375rem] leading-relaxed text-lin-50/70">
              La maturation n’est pas un argument commercial : c’est une enzyme qui travaille.
              L’eau s’évapore, le gras se concentre, les fibres se détendent. À vingt-huit jours,
              un bœuf Charolais prend ce goût de noisette qui ne s’invente pas.
            </p>
            <ul className="mt-6 space-y-2 text-sm text-lin-50/70">
              {['Température et hygrométrie contrôlées en continu', 'Sur os, jamais sous vide', 'Une perte assumée : 18 à 22 % du poids'].map(t => (
                <li key={t} className="flex items-center gap-2.5"><Icon name="check" size={16} className="text-brass-soft" /> {t}</li>
              ))}
            </ul>
          </div>
          <div className="overflow-hidden rounded-[24px]">
            <Media src={PRODUITS.find(p => p.id === 'p_entrecote_maturee')?.photo} alt="Pièce de bœuf en maturation"
              teinte="wine" ratio="aspect-[4/3]" monogramme="28" />
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1180px] px-5 py-16 text-center sm:px-6">
        <h2 className="text-3xl">Venez goûter.</h2>
        <p className="mx-auto mt-3 max-w-lg text-[0.9375rem] text-muted">
          Le meilleur moyen de juger une boucherie reste le même depuis 1922 : pousser la porte.
        </p>
        <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
          <Link to="/nos-boutiques" className={clsBouton('primary')}>Nos boutiques</Link>
          <Link to="/boutique" className={clsBouton('outline')}>Commander en ligne</Link>
        </div>
      </section>
    </main>
  );
}
